import { Avatar, Badge, Box, Chip, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Player, DetailedPlayer, PreventAnswer, Mode } from '../room/types';
import { StagedGameClock } from './StagedGameClock';
import { StagedPlayers } from './StagedPlayers';

type PropTypes = {
  category: string;
  gameClock: number;
  mode: Mode;
  par: number;
  playerSelf: Player;
  playerThem?: Player;
  questionIndex: number;
  totalNumQuestions: number | undefined;
};

export const CustomQuestionsHeader = ({
  category,
  gameClock,
  mode,
  par,
  playerSelf,
  playerThem,
  questionIndex,
  totalNumQuestions,
}: PropTypes) => {
  const scoreLabelValue = (score: string | number, penalty?: number) => (
    <Stack spacing={0} alignItems="center" justifyContent="center" marginX={1}>
      <Typography variant="subtitle1" marginBottom={1}>
        SCORE
      </Typography>
      <Badge
        // anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={penalty || 0}
        color="warning"
        // overlap="circular"
      >
        <Avatar
          sx={{
            border: '1px solid white',
            bgcolor: 'transparent',
            color: 'error.contrastText',
            width: 50,
            height: 50,
          }}
        >
          {score}
        </Avatar>
      </Badge>
    </Stack>
  );

  const desktopHeader = (
    <Stack
      direction="row"
      justifyContent="space-evenly"
      alignItems="center"
      width="100%"
    >
      <Stack direction="row" alignItems="center" spacing={1} width={'200px'}>
        <>
          <StagedPlayers
            imgPath={playerSelf.avatarUrl}
            parScore={playerSelf.parScore}
            correctAnswer={playerSelf.correctAnswer}
            roundScore={playerSelf.currentScore}
          ></StagedPlayers>
          {scoreLabelValue(
            playerSelf.parScore !== undefined
              ? playerSelf.parScore > 0
                ? `+${playerSelf.parScore}`
                : playerSelf.parScore
              : 'N/A',
            playerSelf.totalPenalty
          )}
        </>
      </Stack>

      <Stack direction="column" justifyContent="center">
        <Typography variant="caption" textAlign="center" width="100%">
          {questionIndex + 1} of {totalNumQuestions}
        </Typography>

        <StagedGameClock gameClock={gameClock}></StagedGameClock>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={1}
        >
          <Chip
            label={category || 'None'}
            color="info"
            variant="outlined"
            size="small"
            sx={{
              width: 'fit-content',
              alignSelf: 'center',
              display: { xs: 'none', sm: 'initial' },
            }}
          />
          <Chip
            label={`PAR ${par}`}
            color="info"
            variant="outlined"
            size="small"
            sx={{
              width: 'fit-content',
              alignSelf: 'center',
              display: { xs: 'none', sm: 'initial' },
            }}
          />
        </Stack>
      </Stack>

      <Stack
        direction="row"
        justifyContent={'right'}
        spacing={1}
        width={'200px'}
      ></Stack>
    </Stack>
  );

  return (
    <>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>{desktopHeader}</Box>
    </>
  );
};
